const PlaceIcon = () => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.9999 0.999878C7.51868 0.999878 3.87305 4.64551 3.87305 9.12678C3.87305 10.6021 4.53467 12.1887 4.5624 12.2556C4.77609 12.7628 5.19773 13.5507 5.50177 14.0125L11.074 22.4554C11.302 22.8015 11.6395 22.9999 11.9999 22.9999C12.3604 22.9999 12.6979 22.8015 12.9259 22.4559L18.4986 14.0125C18.8031 13.5507 19.2243 12.7628 19.438 12.2556C19.4657 12.1892 20.1268 10.6025 20.1268 9.12678C20.1268 4.64551 16.4812 0.999878 11.9999 0.999878ZM18.5564 11.8847C18.3657 12.3393 17.9732 13.0722 17.7002 13.4861L12.1276 21.9295C12.0176 22.0964 11.9827 22.0964 11.8728 21.9295L6.30012 13.4861C6.02715 13.0722 5.63467 12.3388 5.44393 11.8842C5.4358 11.8646 4.82915 10.4041 4.82915 9.12678C4.82915 5.1728 8.04597 1.95598 11.9999 1.95598C15.9539 1.95598 19.1707 5.1728 19.1707 9.12678C19.1707 10.406 18.5627 11.8703 18.5564 11.8847Z'
        strokeWidth='0.5'
      />
      <path
        d='M11.9997 4.82495C9.62717 4.82495 7.69727 6.75533 7.69727 9.12743C7.69727 11.4995 9.62717 13.4299 11.9997 13.4299C14.3723 13.4299 16.3022 11.4995 16.3022 9.12743C16.3022 6.75533 14.3723 4.82495 11.9997 4.82495ZM11.9997 12.4738C10.1549 12.4738 8.65337 10.9727 8.65337 9.12743C8.65337 7.28214 10.1549 5.78106 11.9997 5.78106C13.8445 5.78106 15.3461 7.28214 15.3461 9.12743C15.3461 10.9727 13.8445 12.4738 11.9997 12.4738Z'
        strokeWidth='0.5'
      />
    </svg>
  )
}

export default PlaceIcon
